export default __webpack_public_path__ + "static/media/img-0583-iceland-premium-face.48acf982.png";